import { createSlice } from '@reduxjs/toolkit';

const initialState = { demos: [], accounts: [] };

export const accountsSlice = createSlice({
  name: 'accounts',
  initialState: initialState,
  reducers: {
    clearAccounts: (state) => {
      state = initialState;
    },
    setAccounts: (state, action) => {
      return { demos: state.demos, accounts: action.payload };
    },
    addAccount: (state, action) => {
      return { demos: state.demos, accounts: [...state.accounts, action.payload] };
    },
    updateAccount: (state, action) => {
      const provider = action.payload;
      const providerId = provider.providerId;
      const otherProviders = state.accounts.filter((a) => a.providerId != providerId);
      const newList = [provider, ...otherProviders];
      return { demos: state.demos, accounts: newList };
    },
    setDemos: (state, action) => {
      return { demos: action.payload, accounts: state.accounts };
    },
    addDemo: (state, action) => {
      return { demos: [...state.demos, action.payload], accounts: state.accounts };
    },
    updateDemo: (state, action) => {
      const demo = action.payload;
      const demoId = demo.demoId;
      const otherDemos = state.demos.filter((d) => d.demoId != demoId);
      const newList = [demo, ...otherDemos];
      return { demos: newList, accounts: state.accounts };
    },
  },
});

export const { clearAccounts, setAccounts, addAccount, updateAccount, setDemos, addDemo, updateDemo } =
  accountsSlice.actions;

export default accountsSlice.reducer;
